export default __webpack_public_path__ + "static/media/rtl-ios.cb9c6a6f.png";